import { isDDEnv } from '@/utils/helper';

import CutsHeaderDD from './CutsHeaderDD';
import CutsHeaderWH from './CutsHeader';

export default function CutsHeader(props) {
  if (isDDEnv()) {
    return <CutsHeaderDD {...props} />;
  }

  return <CutsHeaderWH {...props} />;
}
